import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { environment } from '@src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class RolesService {

	public baseUrl: string;
	@Output() role: EventEmitter<any> = new EventEmitter();

	constructor(
		private http: HttpClient
		) {
		this.baseUrl = environment.apiUrl;
	}

	public getRoles(): Observable<any>
    {
        return this.http.get(`${this.baseUrl}/roles?filter[guard_name]=api`).pipe();
    }

	public getRole(id): Observable<any>
    {
        return this.http.get(`${this.baseUrl}/roles/${id}`).pipe();
    }

	public updateRole(id, role){
		return this.http.put(`${this.baseUrl}/roles/${id}`, role).pipe();
	}

	public createRole(id, role){
		return this.http.post(`${this.baseUrl}/roles`, role).pipe();
	}

	public editRole(role){
		this.role.emit(role);
	}

	public closeEditRole(){
		this.role.emit(null);
	}

}
